import script from "./insurance-order-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-order-list.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-order-list.vue?vue&type=style&index=0&id=850ef79c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850ef79c"]])

export default __exports__